import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocationProductComponentComponent } from './location-product/location-product-component.component';
import { MerchantProductComponent } from './merchant-product/merchant-product.component';
 import { ProductsComponent } from './products.component';
 

const routes: Routes = [
  {
    path: 'products',
    children: [
    { path: 'list', data: {
      title: 'Products'
    }, component: ProductsComponent},
    {
      path: 'location-products',
      data: {
          title: 'Products in Locations'
      },
      component: LocationProductComponentComponent
    },
    {
      path: 'merchant-products',
      data: {
          title: 'Merchant Products'
      },
      component: MerchantProductComponent
    }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductsRoutingModule { }
